import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./DropOff.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import { FaEdit } from "react-icons/fa";
import { AddDropOffEntity, AddFileDropOffEntity, DropOffEntity, SPECIAL_DROPOFF_KARYAWAN_ID } from "../../entities/DropOffEntity";
import { GoDotFill } from "react-icons/go";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { LuImagePlus } from "react-icons/lu";
import { format } from "date-fns";
import { VendorDropoffService } from "../../services/vendors_dropoff";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import PopupPilih from "../../components/Popup/PopupPilih";
import { KaryawanService } from "../../services/karyawans";
import { VendorPorsiService } from "../../services/vendors_porsi";
import Popup from "../../components/Popup/Popup";


export default function DropOffInput() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  const contextUserEntity = context.contextUserEntity;
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  const [tableData, setTableData] = useState<DropOffEntity[]>([]);

  const [selectedDropOff, setSelectedDropOff] = useState<DropOffEntity | null>(null);
  const [selectedAddDropOff, setSelectedAddDropOff] = useState<AddDropOffEntity | null>(null);
  const [selectedAddFileDropOff, setSelectedAddFileDropOff] = useState<AddFileDropOffEntity | null>(null);

  const [showPopup, setShowPopup] = useState(false);
  const [showPopupFile, setShowPopupFile] = useState(false);
  const [showPopupPilih, setShowPopupPilih] = useState(false);
  const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();
  const [downloadProgress, setDownloadProgress] = useState<number>(0);

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleSelectRequestor = async () => {
    contextShowLoadingFunc(true);
    setShowPopup(false)
    try {
      const resp = await KaryawanService.GetAllKaryawan();
      setPopUpPilihEntity(new PopUpPilihEntity({
        popupTitle: 'Pilih Requestor',
        tableContent: resp,
        onClick: (row) => {
          setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
            return ({
              ...prevState,
              id_requestor: row.id,
              requestor: row.nama
            })
          })
          setShowPopup(true)
        },
        onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
      }))
      setShowPopupPilih(true);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSelectVendorPorsi = async () => {
    contextShowLoadingFunc(true);
    setShowPopup(false)
    try {
      const resp = await VendorPorsiService.GetAllVendorsPorsi(null, null);
      const data: {
        id: number,
        outlet: string,
        shift: number,
        sisa_regular: number,
        sisa_vegetarian: number
      }[] = []
      resp.map((val) => { data.push({ id: val.id, outlet: val.lokasi, shift: val.shift, sisa_regular: val.sisa_regular, sisa_vegetarian: val.sisa_vegetarian }) })
      setPopUpPilihEntity(new PopUpPilihEntity({
        popupTitle: 'Pilih Porsi',
        tableContent: data,
        onClick: (row) => {
          setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
            return ({
              ...prevState,
              id_vendor_porsi: row.id,
              outlet: row.outlet,
              shift: row.shift,
              porsi_reguler_available: row.sisa_regular,
              porsi_vegetarian_available: row.sisa_vegetarian,
            })
          });
          setShowPopup(true)
        },
        onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
      }))
      setShowPopupPilih(true);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  // const handleSelectVendor = async () => {
  //   contextShowLoadingFunc(true);
  //   setShowPopup(false)
  //   try {
  //     const resp = await VendorService.GetAllVendor();
  //     setPopUpPilihEntity(new PopUpPilihEntity({
  //       popupTitle: 'Pilih Vendor',
  //       tableContent: resp,
  //       onClick: (row) => {
  //         setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
  //           return ({
  //             ...prevState,
  //             id_vendor: row.id,
  //             vendor: row.nama
  //           })
  //         });
  //         setShowPopup(true)
  //       },
  //       onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
  //     }))
  //     setShowPopupPilih(true);
  //     contextShowLoadingFunc(false);
  //   } catch (error: any) {
  //     contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
  //     contextShowLoadingFunc(false);
  //   }
  // }

  const handleDownloadFile = async () => {
    if (selectedDropOff == null) return;
    try {
      const resp = await VendorDropoffService.GetFileVendorDropoff(selectedDropOff);
      const file_length = parseInt(resp.headers.get('Content-Length') ?? '0');
      const received = [];
      const reader = resp.body?.getReader()
      let progress = 0;
      while (true) {
        if (reader == undefined) break;
        const { done, value } = await reader.read();
        if (done) break;
        received.push(value);
        progress += value.length;
        setDownloadProgress(progress / file_length * 100)
      }
      const blob = new Blob(received, { type: resp.headers.get("Content-Type") ?? undefined });
      if (resp.status != 200) {
        contextShowLoadingFunc(false);
        return contextShowAlertFunc(new AlertEntity({ message: `[${resp.status}] Not found`, level: 3 }));
      }
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const file_name = (resp.headers.get("Content-disposition") ?? undefined).substring((resp.headers.get("Content-disposition") ?? undefined).indexOf('=') + 1);
      link.setAttribute('download', `${file_name}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      contextShowLoadingFunc(false);
      setDownloadProgress(0)
      return contextShowAlertFunc(new AlertEntity({ message: '[Success]', level: 1 }));
    } catch (error: any) {
      contextShowLoadingFunc(false);
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    }
  }

  const handleAddNew = () => {
    setSelectedAddDropOff({
      tanggal: new Date()
    });
    setSelectedDropOff(null);
    setShowPopup(true);
  }

  const handlePopupDetail = (row: DropOffEntity) => {
    setSelectedDropOff(row);
    setShowPopup(true)
  }

  const handlePopupFile = (row: DropOffEntity) => {
    setSelectedDropOff(row)
    setSelectedAddFileDropOff({ id_vendor_dropoff: row.id });
    setShowPopupFile(true)
  }

  const handleSaveAddVendorDropOff = async () => {
    if (selectedAddDropOff == null || selectedAddDropOff.tanggal == null || selectedAddDropOff.lokasi_drop_off == null
      || selectedAddDropOff.porsi_reguler == null || selectedAddDropOff.shift == null
      || selectedAddDropOff.requestor == null || selectedAddDropOff.porsi_vegetarian == null
      || selectedAddDropOff.id_requestor == null || selectedAddDropOff.id_vendor_porsi == null
    ) return

    contextShowLoadingFunc(true);
    try {
      const resp = await VendorDropoffService.AddVendorDropoff({
        id_vendor_porsi: selectedAddDropOff.id_vendor_porsi,
        id_karyawan: selectedAddDropOff.id_requestor,
        lokasi_dropoff: selectedAddDropOff.lokasi_drop_off,
        shift: selectedAddDropOff.shift,
        qty_regular: selectedAddDropOff.porsi_reguler,
        qty_vegetarian: selectedAddDropOff.porsi_vegetarian
      });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedDropOff(null);
      setSelectedAddDropOff(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSaveUpdateVendorDropOff = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedDropOff == null) { throw new Error("dropoff not selected") }
      const resp = await VendorDropoffService.UpdateVendorDropoff(selectedDropOff, { qty_regular: selectedDropOff.porsi_reguler, qty_vegetarian: selectedDropOff.porsi_vegetarian });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedDropOff(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleDeleteVendorDropOff = async () => {
    return contextShowAlertFunc(new AlertEntity({
      message: `Apakah anda yakin ingin menghapus Drop Off Oleh Requestor ${selectedDropOff?.requestor} ?`,
      onOk: async () => {
        contextShowLoadingFunc(true);
        try {
          if (selectedDropOff == null) { throw new Error("dropoff not selected") }
          const resp = await VendorDropoffService.DeleteVendorDropoff(selectedDropOff);
          await generateData();
          contextShowLoadingFunc(false);
          setSelectedDropOff(null);
          setShowPopup(false);
          contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
          contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
          contextShowLoadingFunc(false);
        }
      },
      withCancel: true,
      withOk: true,
      level: 2
    }))
  }

  const handleSaveAddFileVendorDropOff = async () => {
    if (selectedAddFileDropOff == null || selectedAddFileDropOff.id_vendor_dropoff == null
      || selectedAddFileDropOff.penerima == null || selectedAddFileDropOff.file == null
    ) return
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorDropoffService.UploadDocumentationDropoff({
        id_vendor_dropoff: selectedAddFileDropOff.id_vendor_dropoff,
        penerima: selectedAddFileDropOff.penerima,
        file: selectedAddFileDropOff.file
      });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedDropOff(null);
      setSelectedAddDropOff(null);
      setSelectedAddFileDropOff(null);
      setShowPopupFile(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorDropoffService.GetAllVendorDropoff();
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Drop Off Input"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                  <button className="cardButton" onClick={() => handleAddNew()} >
                    Add New
                  </button>
                </div>
              </div>
            </>
          }
        />
        <div
          style={{ height: "65vh", overflow: "auto" }}>
          <table className="tableclickcell">
            {tableData.length > 0
              ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Tanggal</th>
                    <th>Shift</th>
                    <th>Vendor</th>
                    <th>Lokasi Drop Off</th>
                    <th>Requestor</th>
                    <th>Porsi Reguler</th>
                    <th>Porsi Vegetarian</th>
                    <th>Status</th>
                    <th>Edit</th>
                    <th>Foto</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => {
                    return <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{format(row.tanggal, "yyyy-MM-dd")}</td>
                      <td>{row.shift == 0 ? "No Shift" : row.shift}</td>
                      <td>{row.vendor}</td>
                      <td>{row.lokasi_drop_off}</td>
                      <td>{row.requestor}</td>
                      <td>{row.porsi_reguler}</td>
                      <td>{row.porsi_vegetarian}</td>
                      <td style={{ display: "flex", flexDirection: "row" }}><span style={{ display: "flex", alignItems: "center", color: (row.status == "ACC" ? "#2593C9" : row.status == "DONE" ? "var(--header-color)" : row.status == "WAIT" ? "var(--secondary-color)" : "var(--bad-color)") }}><GoDotFill /></span>{row.status}</td>
                      <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /></td>
                      <td className="group-pick" onClick={() => { handlePopupFile(row) }}><LuImagePlus /></td>
                    </tr>
                  })}
                </tbody>
              </>
              : <thead><tr><th>no data available yet!</th></tr></thead>
            }
          </table>
        </div>

        {/* Popup Detail */}
        <Popup
          setShowPopup={setShowPopup}
          showPopup={showPopup}
          popupTitle={selectedDropOff == null ? "Add New" : `Edit Drop Off Ke ${selectedDropOff?.lokasi_drop_off} (${selectedDropOff.requestor})`}
          popupContent={
            selectedDropOff == null
              ? <div className={css.form}>
                <div className={css.containerleftright}>
                  <div className={css.leftposition}>
                    <div className={css.label}> Tanggal <span style={{ color: "red" }}>*</span></div>
                    <input
                      className={css.inputedit}
                      type="date"
                      value={format(selectedAddDropOff?.tanggal ?? new Date(), "yyyy-MM-dd")}
                      onChange={(event) => {
                        setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
                          return ({
                            ...prevState,
                            tanggal: new Date(event.target.value)
                          })
                        });
                      }}
                    />
                    <div className={css.label}> Lokasi Drop Off<span style={{ color: "red" }}>*</span></div>
                    <input
                      className={css.inputedit}
                      type="text"
                      value={selectedAddDropOff?.lokasi_drop_off ?? ""}
                      onChange={(event) => {
                        setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
                          return ({
                            ...prevState,
                            lokasi_drop_off: event.target.value
                          })
                        });
                      }}
                    />
                    <div className={css.label}> Jumlah Porsi Reguler<span style={{ color: "red" }}>*</span></div>
                    <input
                      className={css.inputedit}
                      type="number"
                      value={selectedAddDropOff?.porsi_reguler ?? ""}
                      onChange={(event) => {
                        setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
                          return ({
                            ...prevState,
                            porsi_reguler: parseInt(event.target.value)
                          })
                        });
                      }}
                    />
                  </div>
                  <div className={css.rightposition}>
                    <div className={css.label}> Outlet & Shift<span style={{ color: "red" }}>*</span></div>
                    <input type="text" readOnly placeholder="Select Outlet & Shift" className={`${css.inputedit} ${css.inputPopup}`}
                      value={selectedAddDropOff?.outlet == null ? "" : `${selectedAddDropOff?.outlet} - ${selectedAddDropOff?.shift}`}
                      onClick={() => { handleSelectVendorPorsi() }}
                    />

                    <div className={css.formGroup}>
                      <label className={css.labelWrapper}>
                        <div className={css.labelHeader}>
                          <span className={css.label}>
                            Requestor <span style={{ color: "red" }}>*</span>
                          </span>

                          <div className={css.checkboxContainer}>
                            <input
                              className={css.checkBox}
                              type="checkbox"
                              id="dropoffSisa"
                              checked={selectedAddDropOff?.id_requestor === SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA}
                              onChange={() => {
                                setSelectedAddDropOff((prevState) => ({
                                  ...prevState,
                                  id_requestor: prevState?.id_requestor === SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA ? undefined : SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA,
                                  requestor: prevState?.id_requestor === SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA ? undefined : "DROPOFF_SISA",
                                }))
                              }}
                            />
                            <label htmlFor="dropoffSisa" className={css.checkboxLabel}>
                              (Centang jika dropoff sisa shift)
                            </label>
                          </div>
                        </div>
                      </label>

                      <div className={css.requestorWrap}>
                        <input type="text" readOnly placeholder="Select Requestor"
                          className={`${css.inputPopup} ${selectedAddDropOff?.id_requestor === SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA ? css.inputDisabled : ""}`}
                          disabled={selectedAddDropOff?.id_requestor === SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA}
                          value={selectedAddDropOff?.requestor ?? ""}
                          onClick={() =>
                            selectedAddDropOff?.id_requestor !== SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA && handleSelectRequestor()
                          }
                        />
                      </div>
                    </div>

                    <div className={css.label}> Jumlah Porsi Vegetarian<span style={{ color: "red" }}>*</span></div>
                    <input
                      className={css.inputedit}
                      type="number"
                      value={selectedAddDropOff?.porsi_vegetarian ?? ""}
                      onChange={(event) => {
                        setSelectedAddDropOff((prevState: AddDropOffEntity | null) => {
                          return ({
                            ...prevState,
                            porsi_vegetarian: parseInt(event.target.value)
                          })
                        });
                      }}
                    />
                  </div>
                </div>
                <div className={css.buttons2}>
                  <div className={css.left}>
                    <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                      Close
                    </button>
                  </div>
                  <div className={css.right}>
                    <button className="primaryButton"
                      onClick={() => { handleSaveAddVendorDropOff() }} >
                      Save
                    </button>
                  </div>
                </div>
              </div>
              : <div className={css.form}>
                <div className={css.containerleftright}>
                  <div className={css.leftposition}>
                    <div className={css.label}> Tanggal <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="date" value={format(selectedDropOff?.tanggal, "yyyy-MM-dd")} readOnly style={{ backgroundColor: "silver" }} />
                    <div className={css.label}> Lokasi Drop Off <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="text" value={selectedDropOff?.lokasi_drop_off ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                    <div className={css.label}> Jumlah Porsi Reguler <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="number" value={selectedDropOff?.porsi_reguler ?? ""}
                      onChange={(event) => {
                        setSelectedDropOff((prevState: DropOffEntity | null) => {
                          if (prevState == null) {
                            return null;
                          } else {
                            return ({
                              ...prevState,
                              porsi_reguler: parseInt(event.target.value)
                            })
                          }
                        });
                      }} />
                  </div>
                  <div className={css.rightposition}>
                    <div className={css.label}> Shift <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="text" value={(selectedDropOff?.shift === 0 ? "No Shift" : selectedDropOff?.shift) ?? ""} readOnly style={{ backgroundColor: "silver" }} />

                    <div className={css.formGroup}>
                      <label className={css.labelWrapper}>
                        <div className={css.labelHeader}>
                          <span className={css.label}>
                            Requestor <span style={{ color: "red" }}>*</span>
                          </span>

                          <div className={css.checkboxContainerDisabled}>
                            <input
                              className={css.checkBoxDisabled}
                              type="checkbox"
                              id="dropoffSisa"
                              checked={selectedDropOff?.id_requestor == SPECIAL_DROPOFF_KARYAWAN_ID.DROPOFF_SISA}
                            />
                            <label htmlFor="dropoffSisa" className={css.checkboxLabel}>
                              (Centang jika dropoff sisa shift)
                            </label>
                          </div>
                        </div>
                      </label>

                      <div className={css.requestorWrap}>
                        <input className={css.inputedit} type="text" value={selectedDropOff?.requestor ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                      </div>
                    </div>

                    <div className={css.label}> Jumlah Porsi Vegetarian <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="number" value={selectedDropOff?.porsi_vegetarian ?? ""}
                      onChange={(event) => {
                        setSelectedDropOff((prevState: DropOffEntity | null) => {
                          if (prevState == null) {
                            return null;
                          } else {
                            return ({
                              ...prevState,
                              porsi_vegetarian: parseInt(event.target.value)
                            })
                          }
                        });
                      }} />
                  </div>
                </div>
                <div className={css.buttons2}>
                  <div className={css.left}>
                    <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                      Close
                    </button>
                  </div>
                  <div className={css.right}>
                    <button className="secondaryButton" onClick={() => handleDeleteVendorDropOff()}>
                      Delete
                    </button>
                  </div>
                  <div className={css.right}>
                    <button className="primaryButton"
                      onClick={() => { handleSaveUpdateVendorDropOff() }} >
                      Save
                    </button>
                  </div>
                </div>
              </div>
          }
        />

        {/* Popup File */}
        <Popup
          setShowPopup={setShowPopupFile}
          showPopup={showPopupFile}
          popupTitle={`Foto Drop Off Ke ${selectedDropOff?.lokasi_drop_off} (${selectedDropOff?.requestor})`}
          popupContent={
            selectedDropOff?.penerima
              ? <div className={css.form}>
                <div className={css.containerleftright}>
                  <div className={css.leftposition}><div className={css.label}> Bukti Foto <span style={{ color: "red" }}>*</span></div>
                    <button className={("primaryButton")} style={{ flexDirection: "column", justifyContent: "start", alignItems: "start" }}
                      onClick={async () => { handleDownloadFile() }} >
                      <div>
                        Download File
                      </div>
                      <div style={{ width: `${downloadProgress}%`, height: "2px", backgroundColor: "#17A8C5" }} />
                    </button>
                  </div>
                  <div className={css.rightposition}>
                    <div className={css.label}> Penerima <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="text" value={selectedDropOff?.penerima ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                  </div>
                </div>
                <div className={css.buttons2}>
                  <div className={css.left}>
                    <button className="tertiaryButton" onClick={() => { setShowPopupFile(false) }} >
                      Close
                    </button>
                  </div>
                </div>
              </div>
              : <div className={css.form}>
                <div className={css.containerleftright}>
                  <div className={css.leftposition}><div className={css.label}> Bukti Foto <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="file"
                      onChange={(event) => {
                        if (event.target.files != null && event.target.files[0] != null) {
                          const file = event.target.files[0];
                          setSelectedAddFileDropOff((prevState: (AddFileDropOffEntity | null)) => {
                            return ({
                              ...prevState,
                              file: file
                            })
                          });
                        }
                      }} />
                  </div>
                  <div className={css.rightposition}>
                    <div className={css.label}> Penerima <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="text" value={selectedAddFileDropOff?.penerima ?? ""}
                      onChange={(event) => {
                        setSelectedAddFileDropOff((prevState: (AddFileDropOffEntity | null)) => {
                          return ({
                            ...prevState,
                            penerima: event.target.value
                          })
                        });
                      }} />
                  </div>
                </div>
                <div className={css.buttons2}>
                  <div className={css.left}>
                    <button className="tertiaryButton" onClick={() => { setShowPopupFile(false) }} >
                      Close
                    </button>
                  </div>
                  <div className={css.right}>
                    <button className="primaryButton"
                      onClick={() => { handleSaveAddFileVendorDropOff() }} >
                      Save
                    </button>
                  </div>
                </div>
              </div>
          }
        />

        {popUpPilihEntity != null
          ? <PopupPilih
            showPopup={showPopupPilih}
            setShowPopup={setShowPopupPilih}
            popUpPilihEntity={popUpPilihEntity}
          />
          : <></>}
      </div>
    </>
  );
}
